import type { ComponentChildren } from "preact";
import { Button, isRefusedSession, ListSkeleton, Notice } from "../../../ui/src/index.ts";
import { describeFailure } from "../api.ts";
import type { ApiFailure } from "../domain/types.ts";
import { signOut } from "./actions.ts";

/** `tour` names the section for a walkthrough step to point at. */
export function Section({ title, note, action, tour, children }: { title: string; note?: string; action?: ComponentChildren; tour?: string; children: ComponentChildren }) {
  return <section class="st-section" data-tour={tour}><div class="st-section__head"><div><h2>{title}</h2>{note && <p class="st-note">{note}</p>}</div>{action}</div>{children}</section>;
}

export function Loading({ label }: { label: string }) {
  return <div class="st-loading" role="status" aria-busy="true" aria-label={label}><ListSkeleton rows={4} /></div>;
}

/** The Exchange refused this account, so retrying can't help; the way out is to sign out and use another. */
export function Refused({ error, onSignOut }: { error: ApiFailure; onSignOut: () => void }) {
  return <Notice tone="danger" title="This account can't use Curator Studio" action={<Button size="sm" variant="solid" onClick={onSignOut}>Sign out of WarmHub to use another account</Button>}>
    {error.detail ?? "Your WarmHub account has no WarmHub user yet, and sign-up isn't open here. Sign in to WarmHub once, then come back."}
  </Notice>;
}

export function Failed({ what, error, retry, notFound }: { what: string; error: ApiFailure; retry: () => void; notFound?: string }) {
  if (isRefusedSession(error)) return <Refused error={error} onSignOut={signOut} />;
  return <Notice tone="danger" title={`Studio couldn't read ${what}`} action={<Button size="sm" onClick={retry}>Try again</Button>}>{describeFailure(error, notFound)}</Notice>;
}
